import { render, staticRenderFns } from "./BusinessStatistics.vue?vue&type=template&id=151b567a"
import script from "./BusinessStatistics.vue?vue&type=script&lang=js"
export * from "./BusinessStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports